import { Controller } from "@hotwired/stimulus"

const ITEM = ".assistant-nav-title, a[data-core-nav], a[data-rail-app], .rail-chats-heading, .rail-chat-link"
const TABLET_TOUCH = "(min-width: 768px) and (hover: none) and (pointer: coarse)"

// Touch tablets use the same menus as the desktop rail, without keeping every
// action button on screen. Scrolling, a second finger, and short taps retain
// their normal behavior. Keyboard users can also press Shift+F10 on a row.
export default class extends Controller {
    connect() {
        this.down = event => this.start(event)
        this.move = event => {
            if (this.tracking && (Math.abs(event.clientX - this.tracking.x) > 10 || Math.abs(event.clientY - this.tracking.y) > 10)) this.cancel()
        }
        this.up = () => this.cancel()
        this.click = event => {
            if (this.opening || event.detail === 0 || !this.held?.contains(event.target)) return
            event.preventDefault()
            event.stopImmediatePropagation()
            this.held = null
        }
        this.onContext = event => {
            if (this.opening || !window.matchMedia(TABLET_TOUCH).matches) return
            const item = this.item(event.target)
            if (!item) return
            event.preventDefault()
            event.stopImmediatePropagation()
            this.cancel()
            if (this.held !== item) this.open(item)
            this.held = item
        }
        this.key = event => {
            if (event.key !== "ContextMenu" && !(event.shiftKey && event.key === "F10")) return
            const item = this.item(event.target)
            if (!item) return
            event.preventDefault()
            this.open(item)
        }
        this.element.addEventListener("pointerdown", this.down)
        this.element.addEventListener("pointermove", this.move)
        this.element.addEventListener("pointerup", this.up)
        this.element.addEventListener("pointercancel", this.up)
        this.element.addEventListener("scroll", this.up, { passive: true })
        this.element.addEventListener("click", this.click, true)
        this.element.addEventListener("contextmenu", this.onContext, true)
        this.element.addEventListener("keydown", this.key)
    }

    disconnect() {
        this.cancel()
        this.element.removeEventListener("pointerdown", this.down)
        this.element.removeEventListener("pointermove", this.move)
        this.element.removeEventListener("pointerup", this.up)
        this.element.removeEventListener("pointercancel", this.up)
        this.element.removeEventListener("scroll", this.up)
        this.element.removeEventListener("click", this.click, true)
        this.element.removeEventListener("contextmenu", this.onContext, true)
        this.element.removeEventListener("keydown", this.key)
    }

    item(target) {
        const item = target.closest?.(ITEM)
        if (!item || !this.element.contains(item)) return null
        if (item.matches("a[data-core-nav], a[data-rail-app]")) return item
        return this.button(item) ? item : null
    }

    button(item) {
        if (item.matches(".assistant-nav-title")) return item.closest(".assistant-nav-title-row").querySelector("[data-sidebar-title-menu]")
        if (item.matches(".rail-chats-heading")) return item.closest(".rail-chats-header").querySelector("[data-split-menu-target='caret']")
        return item.closest(".rail-chat, .rail-project-row")?.querySelector(".rail-chat-more")
    }

    start(event) {
        this.cancel()
        this.held = null
        if (!event.isPrimary || event.pointerType !== "touch" || !window.matchMedia(TABLET_TOUCH).matches) return
        const item = this.item(event.target)
        if (!item) return
        this.tracking = { x: event.clientX, y: event.clientY }
        this.timer = setTimeout(() => {
            this.held = item
            this.open(item)
            this.cancel()
        }, 550)
    }

    cancel() {
        clearTimeout(this.timer)
        this.tracking = null
    }

    open(item) {
        this.opening = true
        try {
            const button = this.button(item)
            if (button) return button.click()
            const rect = item.getBoundingClientRect()
            item.dispatchEvent(new MouseEvent("contextmenu", { bubbles: true, cancelable: true, clientX: rect.right - 24, clientY: rect.bottom }))
        } finally {
            this.opening = false
        }
    }
}
